import { useEffect, useState } from 'react';

export function useDelayedValue<T>(value: T, delay = 500, skip = false): T {
  const [delayedValue, setDelayedValue] = useState(value);

  useEffect(() => {
    if (skip) {
      setDelayedValue(value);
      return;
    }

    const timer = setTimeout(() => {
      setDelayedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay, skip]);

  return delayedValue;
}
